import React from 'react'

import Icon from 'components/Icon'
import Currency from 'components/Pricing/components/Currency'
import Tag from 'components/Tag'
import Typography from 'components/Typography'
import { mapPricingCategories, getPricingTexts } from 'helpers/dataTransformers/pricing'
import { priceFormatter } from 'helpers/formatters'
import useViewport from 'hooks/useViewport'

import classes from './PricingDetails.module.scss'

/** @type {import("./types").default} */
const PricingDetails = ({ pricing }) => {
  const { periodicityText, pricingModelText } = getPricingTexts(pricing)
  const { hasFreeTrial } = mapPricingCategories(pricing?.categories)

  const hasPrice = Number(pricing?.amount) > 0
  const isFree = !hasPrice

  const { up } = useViewport()
  const isDesktop = up('lg')

  return (
    <div className={classes.root}>
      <div className={classes.amountWrapper}>
        {hasPrice && !isFree && (
          <div className={classes.amount}>
            <Currency pricing={pricing} />
            <Typography variant="heading-md" component="span">
              {priceFormatter(pricing?.amount)}
            </Typography>
          </div>
        )}

        {isDesktop && !isFree && (
          <Tag className={classes.tag} size="tiny" color={hasFreeTrial ? 'teal' : 'grey'} disableRipple>
            Free trial
            <Icon icon={hasFreeTrial ? 'check' : 'times'} size="12" />
          </Tag>
        )}
      </div>

      {isFree ? (
        <div className={classes.amountWrapper}>
          <Typography component="span" className={classes.free}>
            Free
          </Typography>
          {isDesktop && (
            <Tag className={classes.tag} size="tiny" color={hasFreeTrial ? 'teal' : 'grey'} disableRipple>
              Free trial
              <Icon icon={hasFreeTrial ? 'check' : 'times'} size="12" />
            </Tag>
          )}
        </div>
      ) : (
        <Typography variant="tight-xxs" component="span">
          {pricingModelText}
          {periodicityText ? '/' : ''}
          {periodicityText}
        </Typography>
      )}
    </div>
  )
}

export default PricingDetails
